module.exports = __webpack_public_path__ + "static/media/play-button (1).ab0c46a4.svg";